export default "__VITE_ASSET__pppMosZR__"